import ServiceClient from "src/utils/extension/ServiceClient";
import { getWhatnotCookies } from "src/utils/extension/whatnot";

const WhatnotHeaderAcceptLanguage = "en-US";

// const GetLedgerOverviewQuery = "query GetLedgerOverview($after:String$first:Int$filters:LedgerFilter){me{id ledgerTransactions(after:$after first:$first filters:$filters){pageInfo{hasNextPage hasPreviousPage startCursor endCursor __typename}edges{cursor node{...LedgerOverviewNode __typename}__typename}__typename}__typename}}fragment Money on Money{amount currency amountSafe __typename}fragment LedgerOverviewNode on LedgerTransactionNode{id amount{...Money __typename}createdAt completedAt message listingId:listingIdV2 transactionType status statusUpdatedAt order{id uuid __typename}__typename}";
// const GetLedgerOverviewQuery = "query GetLedgerOverview($after:String,$first:Int,$filters:LedgerFilter){me{id ledgerTransactions(after:$after,first:$first,filters:$filters){pageInfo{hasNextPage hasPreviousPage startCursor endCursor __typename}edges{cursor node{...LedgerOverviewNode __typename}__typename}__typename}__typename}}fragment Money on Money{amount currency amountSafe __typename}fragment LedgerOverviewNode on LedgerTransactionNode{id amount{...Money __typename}createdAt completedAt message listingId:listingIdV2 transactionType status statusUpdatedAt order{...Order __typename}__typename}fragment DirectMessageUser on PublicUserNode{id username displayName isVerifiedSeller profileImage{id bucket key __typename}canBeMessagedByMe isBlockedByMe isBlockingMe isFollower isFollowing directMessagingDisabled premierShopStatus{isPremierShop __typename}__typename}fragment OrderUser on PublicUserNode{...DirectMessageUser __typename}fragment ListingImageFragment on ListingImage{id url key bucket label __typename}fragment ListingPreviewOnOrder on ListingNode{id title description category{id label __typename}images{...ListingImageFragment __typename}actions{action label __typename}__typename}fragment ProductPreviewOnOrder on ProductNode{id name slug videoUrl gifVideoUrl thumbnailVideoUrl image{id bucket url key __typename}__typename}fragment OrderAppealLabel on OrderNode{id latestRefundAppealNode{id entity{...on OrderRefundNode{id prettyOrdersPageChip{text variant __typename}__typename}__typename}__typename}__typename}fragment OrderStatusLabel on OrderNode{id status prettyStatus refundRequest{id prettyStatus __typename}__typename}fragment Order on OrderNode{id total{...Money __typename}subtotal{...Money __typename}taxes{...Money __typename}shippingPrice{...Money __typename}createdAt prettyStatuses prettyStatus salesChannel channelReference videoReceipt{videoUrl expirationMessage status __typename}uuid status shippingAddress{id fullName line1 line2 city state postalCode countryCode __typename}isAppealable latestRefundAppealNode{id entity{...on OrderRefundNode{id prettyODPAppealInfo{status{text variant __typename}description updatedAt __typename}__typename}__typename}__typename}refundRequest{id status prettyStatus prettyStatusDescription prettyStatusDescriptionDate reasonMessage returnShipmentParty group{id conversation{id __typename}__typename}__typename}supportConversations{id __typename}seller{...OrderUser __typename}buyer{...OrderUser __typename}items{edges{node{id status cancellationReason listing{...ListingPreviewOnOrder __typename}product{...ProductPreviewOnOrder __typename}quantity shipmentId livestreamProduct{id livestream{id title __typename}__typename}sellerReceipt{title description subtotal{title amount __typename}lineItems{title subtitle amount paymentProcessingFeeDetails{title lineItems{title subtitle amount userFacingContext __typename}description totalLineItem{title subtitle amount userFacingContext __typename}__typename}userFacingContext __typename}netEarnings{title amount userFacingContext __typename}adjustedEarningsDetails{title description lineItems{amount subtitle title paymentProcessingFeeDetails{description title lineItems{amount subtitle title userFacingContext __typename}totalLineItem{title subtitle amount userFacingContext __typename}__typename}userFacingContext __typename}netAdjustedEarnings{amount subtitle title userFacingContext __typename}__typename}__typename}__typename}__typename}__typename}...OrderAppealLabel...OrderStatusLabel __typename}";
// const GetLedgerOverviewQuery =
//   "query GetLedgerOverview($after:String,$first:Int,$filters:LedgerFilter){me{id ledgerTransactions(after:$after,first:$first,filters:$filters){pageInfo{hasNextPage endCursor __typename}edges{node{...LedgerOverviewNode __typename}__typename}__typename}__typename}}fragment Money on Money{amount __typename}fragment LedgerOverviewNode on LedgerTransactionNode{id amount{...Money __typename}createdAt completedAt message transactionType status statusUpdatedAt order{...LedgerOrder __typename}__typename}fragment LedgerOrder on OrderNode{id uuid createdAt prettyStatus status subtotal{...Money __typename}taxes{...Money __typename}shippingAddress{state __typename}refundRequest{status prettyStatusDescriptionDate __typename}items{edges{node{quantity listing{title category{label __typename}__typename}sellerReceipt{description subtotal{amount __typename}lineItems{title amount __typename}netEarnings{amount __typename}adjustedEarningsDetails{lineItems{title amount __typename}netAdjustedEarnings{amount __typename}__typename}__typename}__typename}__typename}__typename}__typename}";
const GetLedgerOverviewQuery =
  "query GetLedgerOverview($after:String,$first:Int,$filters:LedgerFilter){me{id ledgerTransactions(after:$after,first:$first,filters:$filters){pageInfo{hasNextPage endCursor __typename}edges{node{...LedgerOverviewNode __typename}__typename}__typename}__typename}}fragment Money on Money{amount __typename}fragment LedgerOverviewNode on LedgerTransactionNode{id amount{...Money __typename}createdAt completedAt message transactionType status statusUpdatedAt order{...LedgerOrder __typename}__typename}fragment LedgerOrder on OrderNode{id uuid createdAt prettyStatus status subtotal{...Money __typename}taxes{...Money __typename}shippingAddress{state __typename}refundRequest{status prettyStatusDescriptionDate __typename}items{edges{node{quantity listing{title category{label __typename}sku variants{productVariant{sku __typename}__typename}__typename}sellerReceipt{description subtotal{amount __typename}lineItems{title amount __typename}netEarnings{amount __typename}adjustedEarningsDetails{lineItems{title amount __typename}netAdjustedEarnings{amount __typename}__typename}__typename}__typename}__typename}__typename}__typename}";

export class NotLoggedError extends Error {
  constructor() {
    super("You must be logged in Whatnot to perform the sync process.");
  }
}

export class UnauthorizedError extends Error {
  url: string;
  status: number;
  json: object;

  constructor(operation: string, url: string, status: number, json: object) {
    super(`(whatnot) ${operation} Failed (unauthorized error property)`);
    this.url = url;
    this.status = status;
    this.json = json;
  }
}

class WhatnotClient extends ServiceClient {
  async getUserIdFromCookie(): Promise<string> {
    const cookies = await getWhatnotCookies(this.extensionId);
    const refreshToken = cookies.find(
      (c) => c.name === "__Secure-refresh-token"
    )?.value;
    if (!refreshToken) throw new NotLoggedError();

    try {
      const segment = refreshToken.split(".")[1];
      const payload = JSON.parse(atob(segment));
      if (payload.sub) return payload.sub;
    } catch (_) {}

    const res = await this.fetch("https://www.whatnot.com/", {
      headers: {
        Accept: "*/*",
        "accept-language": WhatnotHeaderAcceptLanguage,
      },
      method: "GET",
    });
    const match = res.data?.match(/\\"userID\\":\\"?(.*?)\\"?[,}]/);
    if (match?.[1]) return match[1];

    throw new NotLoggedError();
  }

  async getUsername(): Promise<string> {
    const res = await this.fetch("https://www.whatnot.com/", {
      headers: {
        Accept: "*/*",
        "accept-language": WhatnotHeaderAcceptLanguage,
      },
      method: "GET",
    });
    const text = res.data;
    if (!res.ok) throw new Error(`Couldn't get username (not ok)`);
    if (!text) throw new Error(`Couldn't get username (not text)`);
    const match = text.match(/\\"username\\":\\"([^\\]+)\\"/);
    if (!match) throw new Error(`Couldn't get username (not match)`);
    return match[1];
  }

  async getMyOrders({
    after = null,
    first = 1000,
  }: {
    after?: string | null;
    first?: number;
  } = {}) {
    const url =
      "https://www.whatnot.com/services/graphql/?operationName=SellerHubGetMyOrders&ssr=0";
    const res = await this.fetchWithRetry(
      url,
      {
        headers: {
          authorization: "Cookie",
          "content-type": "application/json",
          "accept-language": WhatnotHeaderAcceptLanguage,
        },
        body: JSON.stringify({
          operationName: "SellerHubGetMyOrders",
          variables: {
            after,
            before: null,
            channel: [],
            filter: [],
            first,
            includeSellerReceipt: true,
            last: null,
            orderStyles: [
              "DIRECT_OFFER",
              "DIRECT_ORDER",
              "OFFER",
              "ORDER",
              "GIVEAWAY",
            ],
            query: null,
            salesChannels: [],
            sellerId: null,
            sortDirection: "desc",
            sortField: "DATE",
            status: [],
            useOrderRecord: false,
          },
          query:
            "query SellerHubGetMyOrders($before:String$after:String$first:Int$last:Int$query:String$sellerId:ID$status:[OrderStatus]$filter:[OrderFilter]$channel:[OrderChannel]$orderStyles:[OrderStyle]$sortField:SearchResultSortField$sortDirection:SearchResultSortDirection$salesChannels:[SalesChannelInfoInput]$useOrderRecord:Boolean!$includeSellerReceipt:Boolean!){me{id orders(before:$before after:$after first:$first last:$last query:$query sellerId:$sellerId status:$status orderStyles:$orderStyles filter:$filter channel:$channel sortField:$sortField sortDirection:$sortDirection salesChannels:$salesChannels){pageInfo{hasNextPage hasPreviousPage endCursor startCursor __typename}totalCount edges{node{id uuid buyer{id username canBeMessagedByMe directMessagingDisabled __typename}createdAt salesChannel subtotal{amount currency __typename}fixedAmountCouponDiscount{amount currency __typename}couponCode total{amount currency __typename}prettyStatus refundRequest{id prettyStatus __typename}supportConversations{id hasUnreadDirectMessages __typename}items(first:1){edges{node{id quantity listing{id title@skip(if:$useOrderRecord)images@skip(if:$useOrderRecord){id url __typename}auctionInfo{channelId __typename}status __typename}record@include(if:$useOrderRecord){id title images{id url __typename}__typename}sellerReceipt@include(if:$includeSellerReceipt){adjustedEarningsDetails{netAdjustedEarnings{amount __typename}__typename}earningsStatus{badgeLabel sheetTitle sheetBody __typename}netEarnings{amount __typename}__typename}__typename}__typename}__typename}...OrderAppealLabel ...OrderStatusLabel __typename}__typename}__typename}__typename}}fragment OrderAppealLabel on OrderNode{id latestRefundAppealNode{id entity{...on OrderRefundNode{id prettyOrdersPageChip{text variant __typename}__typename}__typename}__typename}__typename}fragment OrderStatusLabel on OrderNode{id prettyStatus refundRequest{id prettyStatus __typename}__typename}",
        }),
        method: "POST",
      },
      {
        retries: 10,
        wait: 30000,
        isOk: (res) => {
          const length = res.data?.data?.me?.orders?.edges?.length;
          if (!res.ok) return false;
          if (length) return true;
          return !res.data?.errors?.length;
        },
      }
    );

    if (!res.ok) {
      console.error(res);
      console.error("(whatnot) getMyOrders failed (status code)", {
        url,
        body: res.data,
        status: res.status,
      });

      throw new Error("(whatnot) getMyOrders Failed (status code)");
    }

    return res.data.data.me.orders;
  }

  async *getMyOrdersFull() {
    let after: string | null = null;

    do {
      const res = await this.getMyOrders({ after });
      after = res.pageInfo.endCursor;
      yield res.edges;
      if (!res.pageInfo.hasNextPage) break;
    } while (after);
  }

  async myOrder(orderId: string) {
    const url =
      "https://www.whatnot.com/services/graphql/?operationName=MyOrder&ssr=0";
    const res = await this.fetchWithRetry(
      url,
      {
        headers: {
          authorization: "Cookie",
          "content-type": "application/json",
          "accept-language": WhatnotHeaderAcceptLanguage,
        },
        body: JSON.stringify({
          operationName: "MyOrder",
          variables: {
            uuid: orderId,
          },
          // This query adds the `adjustedEarningsDetails` of the `GetOrderReceipts` call
          query:
            "query MyOrder($uuid: ID!) { myOrder(uuid: $uuid) { ...Order __typename }}fragment Money on Money { amount currency amountSafe __typename}fragment DirectMessageUser on PublicUserNode { id username displayName isVerifiedSeller profileImage { id bucket key __typename } canBeMessagedByMe isBlockedByMe isBlockingMe isFollower isFollowing directMessagingDisabled premierShopStatus { isPremierShop __typename } __typename}fragment OrderUser on PublicUserNode { ...DirectMessageUser __typename}fragment ListingImageFragment on ListingImage { id url key bucket label __typename}fragment ListingPreviewOnOrder on ListingNode { id title description category { id label __typename } images { ...ListingImageFragment __typename } actions { action label __typename } __typename}fragment ProductPreviewOnOrder on ProductNode { id name slug videoUrl gifVideoUrl thumbnailVideoUrl image { id bucket url key __typename } __typename}fragment OrderAppealLabel on OrderNode { id latestRefundAppealNode { id entity { ... on OrderRefundNode { id prettyOrdersPageChip { text variant __typename } __typename } __typename } __typename } __typename}fragment OrderStatusLabel on OrderNode { id status prettyStatus refundRequest { id prettyStatus __typename } __typename}fragment Order on OrderNode { id total { ...Money __typename } subtotal { ...Money __typename } taxes { ...Money __typename } shippingPrice { ...Money __typename } createdAt prettyStatuses prettyStatus salesChannel channelReference videoReceipt { videoUrl expirationMessage status __typename } uuid status shippingAddress { id fullName line1 line2 city state postalCode countryCode __typename } isAppealable latestRefundAppealNode { id entity { ... on OrderRefundNode { id prettyODPAppealInfo { status { text variant __typename } description updatedAt __typename } __typename } __typename } __typename } refundRequest { id status prettyStatus prettyStatusDescription prettyStatusDescriptionDate reasonMessage returnShipmentParty group { id conversation { id __typename } __typename } __typename } supportConversations { id __typename } seller { ...OrderUser __typename } buyer { ...OrderUser __typename } items { edges { node { id status cancellationReason listing { ...ListingPreviewOnOrder __typename } product { ...ProductPreviewOnOrder __typename } quantity shipmentId livestreamProduct { id livestream { id title __typename } __typename } sellerReceipt { title description subtotal { title amount __typename } lineItems { title subtitle amount paymentProcessingFeeDetails { title lineItems { title subtitle amount userFacingContext __typename } description totalLineItem { title subtitle amount userFacingContext __typename } __typename } userFacingContext __typename } netEarnings { title amount userFacingContext __typename } adjustedEarningsDetails { title description lineItems { amount subtitle title paymentProcessingFeeDetails { description title lineItems { amount subtitle title userFacingContext __typename } totalLineItem { title subtitle amount userFacingContext __typename } __typename } userFacingContext __typename } netAdjustedEarnings { amount subtitle title userFacingContext __typename } __typename } __typename } __typename } __typename } __typename } ...OrderAppealLabel ...OrderStatusLabel __typename}",
        }),
        method: "POST",
      },
      { retries: 10, wait: 10000 }
    );

    if (!res.ok) {
      console.error(res);
      console.error("(whatnot) MyOrder failed (status code)", {
        url,
        body: res.data,
        status: res.status,
      });

      throw new Error("(whatnot) MyOrder Failed (status code)");
    }

    return res.data.data.myOrder;
  }

  async getLedgerOverview({
    after = null,
    first = 1000,
    startTime = null,
    endTime = null,
  }: {
    after?: string | null;
    first?: number;
    startTime?: number | null; // epoch seconds
    endTime?: number | null; // epoch seconds
  } = {}) {
    const url =
      "https://www.whatnot.com/services/graphql/?operationName=GetLedgerOverview&ssr=0";
    const res = await this.fetchWithRetry(
      url,
      {
        headers: {
          authorization: "Cookie",
          "content-type": "application/json",
          "accept-language": WhatnotHeaderAcceptLanguage,
        },
        body: JSON.stringify({
          operationName: "GetLedgerOverview",
          variables: {
            after,
            first,
            filters: {
              endTime,
              startTime,
            },
          },
          query: GetLedgerOverviewQuery,
        }),
        method: "POST",
      },
      {
        retries: 10,
        wait: 5000,
        isOk: (res) => {
          if (!res.ok) return false;
          if (res.data?.errors?.length) return false;
          return !!res.data?.data?.me?.ledgerTransactions;
        },
      }
    );

    if (!res.ok) {
      console.error(res);
      console.error("(whatnot) getLedgerOverview failed (status code)", {
        url,
        body: res.data,
        status: res.status,
      });

      throw new Error("(whatnot) getLedgerOverview Failed (status code)");
    }

    return res.data.data.me.ledgerTransactions;
  }

  async *getLedgerOverviewFull(
    props: {
      startTime?: number | null; // epoch seconds
      endTime?: number | null; // epoch seconds
    } = {}
  ) {
    let after: string | null = null;

    do {
      const res = await this.getLedgerOverview({ ...props, after });
      after = res.pageInfo.endCursor;
      yield res.edges;
      if (!res.pageInfo.hasNextPage) break;
    } while (after);
  }
}

export default WhatnotClient;
